<template>
    <div class="node-properties-inner">
        <select v-model="properties.groupKey">
            <option value="red,yellow">Warm Colours</option>
            <option value="green,blue">Cool Colours</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>
